import React, { ComponentPropsWithoutRef } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@rbx/ui';
import useMarkdownAccordionStyles from './MarkdownAccordion.styles';

type AccordionProps = ComponentPropsWithoutRef<typeof Accordion>;

export interface MarkdownAccordionProps extends AccordionProps {
  title: string;
}

export default function MarkdownAccordion({ title, children }: MarkdownAccordionProps) {
  const {
    classes: { accordion },
  } = useMarkdownAccordionStyles();

  return (
    <Accordion
      classes={{
        root: accordion,
      }}>
      <AccordionSummary>{title}</AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
